
import { ProjectTableRow } from 'modules/components/layer23';
import { StyledTable } from 'modules/components/layer24';

import React, { useMemo } from 'react';
import * as ds from './dataService';



export type ProjectTableProps = {};

/* eslint-disable-next-line @typescript-eslint/no-unused-vars */
export const FC = (props: ProjectTableProps) => {
  const { data } = ds.useQuery();
  const headers: string[] = [
    'Start Date',
    'Client',
    'Address',
    'status',
    ''
  ];

  const rows = useMemo(() => {
    return data.map((node, i) => {
      return (
        <ProjectTableRow.FC
          key={i}
          id={node.id}
          location=''
          fullAddress={node.fullAddress}
          clientName={node.clientName}
          dateCreated={node.estimatedStartDate}
          status='Active'
        />
      );
    });
  }, [data]);

  return (
    <StyledTable.FC
      headers={headers}
      rows={rows}
    />

  );
};
